import { useSearchParams } from "react-router";

import {
  SearchStateAccept,
  SearchStateReturn,
  SearchValue,
  UseSearchStateOptions,
  inferAcceptsFromInitialValue,
  useSearchState,
} from "@nens/react/hooks";

/* tslint:disable */
/* eslint-disable */
type IgnoreAny = any;

export interface ExtraOptions
  extends Omit<UseSearchStateOptions, "setSearchParams" | "searchParams"> {
  disableSettingParams?: boolean;
}

export function useRanaSearchState(
  key: string,
  initialValue: boolean,
  options?: ExtraOptions
): SearchStateReturn<boolean>;

export function useRanaSearchState(
  key: string,
  initialValue: string,
  options?: ExtraOptions
): SearchStateReturn<string>;

export function useRanaSearchState(
  key: string,
  initialValue: number,
  options?: ExtraOptions
): SearchStateReturn<number>;

export function useRanaSearchState(
  key: string,
  initialValue: null,
  options?: ExtraOptions
): SearchStateReturn<null>;

export function useRanaSearchState(
  key: string,
  initialValue: undefined,
  options?: ExtraOptions
): SearchStateReturn<undefined>;

export function useRanaSearchState<T extends SearchValue>(
  key: string,
  initialValue: T,
  options?: ExtraOptions
): SearchStateReturn<T>;

export function useRanaSearchState<T extends SearchValue>(
  key: string,
  initialValue: T,
  accepts: SearchStateAccept<T>[],
  options?: ExtraOptions
): SearchStateReturn<T>;

export function useRanaSearchState<T extends SearchValue[]>(
  key: string,
  initialValue: T,
  accepts: SearchStateAccept<T[number]>[],
  options?: ExtraOptions
): SearchStateReturn<T>;

export function useRanaSearchState<T extends SearchValue | SearchValue[]>(
  key: string,
  initialValue: T,
  acceptsOrOptions?: SearchStateAccept<SearchValue>[] | ExtraOptions,
  maybeOptions?: ExtraOptions
): SearchStateReturn<T> {
  const accepts = Array.isArray(acceptsOrOptions)
    ? acceptsOrOptions
    : inferAcceptsFromInitialValue(initialValue);
  const options = Array.isArray(acceptsOrOptions) ? maybeOptions : acceptsOrOptions;
  const { disableSettingParams, ...restOptions } = options || {};

  const [searchParams, setSearchParams] = useSearchParams();

  return useSearchState(
    key,
    initialValue as IgnoreAny,
    accepts,
    disableSettingParams ? restOptions : { searchParams, setSearchParams, ...restOptions }
  );
}
